import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, checkTokenExpiration } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Check if token is valid on component mount and when route changes
  useEffect(() => {
    if (isAuthenticated) {
      // Check if token is expired
      checkTokenExpiration();
    } else {
      // Redirect to login with the return URL
      navigate('/login', { 
        state: { from: location.pathname },
        replace: true
      });
    }
  }, [isAuthenticated, checkTokenExpiration, navigate, location.pathname]);

  // If not authenticated, don't render anything while the redirect happens
  if (!isAuthenticated) {
    return null;
  }

  // If authenticated, render the children
  return <>{children}</>;
};

export default ProtectedRoute;
